// WobblyTitle.jsx
import React from "react";

function wobbleFor(i, seed = 7) {

  const r = Math.sin(i * 91.345 + seed) * 0.5 + 0.5; 
  const y = (r - 0.5) * 10;   
  const rot = (r - 0.5) * 6; 
  return { y, rot };
}

export default function WobblyTitle({ text, className = "" }) {
  return (
    <h2 className={`wobbly-title ${className}`} aria-label={text}>
      {text.split("").map((ch, i) => {
        if (ch === " ") return <span key={i} className="char space">&nbsp;</span>;
        const { y, rot } = wobbleFor(i);
        return (
          <span
            key={i}
            className="char"
            style={{ transform: `translateY(${y}px) rotate(${rot}deg)` }}
          >
            {ch}
          </span>
        );
      })}
    </h2>
  );
}
